//
import React from "react";
//component
import SegmentDetail from "component/segment_detail/segment_detail";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
//redux
//selector
//actions
//utils
//hook
import { useSearchParams } from "react-router-dom";
//str

const DialogPreviewSegment = () => {
  // -------------------------- VAR -----------------------------
  const [searchParams, setSearchParams] = useSearchParams();
  const slot = searchParams.get("slot") || null;
  const tab = searchParams.get("tab") || "not_edit";
  const open = !!slot;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleCancel = () => {
    if (!tab) return;
    setSearchParams({ tab });
    console.log({ searchParams });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderCloseIcon = () => {
    return (
      <Button
        onClick={handleCancel}
        className="absolute right-5 self-center"
        icon={<CloseOutlined />}
      />
    );
  };

  const renderHeader = () => {
    return (
      <div className="flex w-full flex-[0.1] flex-row items-center justify-center border-b-[1px] border-gray-300">
        <Typography.Title style={{ margin: 0 }} level={3}>
          Preview Trích Đoạn {slot}
        </Typography.Title>
        {renderCloseIcon()}
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  if (!open) return null;
  return (
    <div className="fixed bottom-0 left-0 right-0 top-0 z-[2] flex w-full flex-col items-center justify-center overflow-hidden bg-white">
      {renderHeader()}
      <div className="flex-[0.95] overflow-auto">
        <SegmentDetail />
      </div>
    </div>
  );
};
export default DialogPreviewSegment;
